/*@flow*/
import validate from './validate';

export default function invariant(value: any, type: any, msg: string) {
  if (validate(value, type).isValid()) return;
  throw new Error(msg);
}
